import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { GetBlob } from '@/api/api-middleware';
import { getCompanyID } from '@/helpers/Utils';
import { apiPath } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchWorkFlowStage = createAsyncThunk(
  'workFlowStages/fetchWorkFlowAssignType',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetWorkFlowStages();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.id,
        })) ?? [];
      return [...mappedData];
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
export const GetAttachments = async (params, thunkAPI) => {
  try {
    const response = await GetBlob({
      url: `${apiPath}${'api/Operations/WorkFlow/GetAttachments/'}EMPLOYEE/${getCompanyID()}/${params}`,
    });

    if (response) {
      // Use 'application/pdf' or other MIME type from 'Content-Type'
      const contentType = response?.type ?? 'application/octet-stream';

      // Default filename if 'Content-Disposition' is missing
      const fileExtension = contentType.split('/')[1] || 'bin'; // Extract extension from MIME type
      const fileName = `downloaded_file.${fileExtension}`; // Default fallback filename

      // Create a blob URL and trigger the download
      const url = window.URL.createObjectURL(
        new Blob([response], { type: contentType })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName); // Set the filename
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return response;
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(error.message);
  }
};

const downloadFile = async (data) => {
  try {
    const blob = new Blob([data.data], { type: data.headers['content-type'] });
    const url = window.URL.createObjectURL(blob);
    const fileName = data.headers['x-file-name'] || 'Report';
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.log(error);
  }
};
const initialState = {
  workFlowStagesList: [],
  loading: false,
  error: '',
};

const workFlowStagesSlice = createSlice({
  name: 'workFlowStages',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkFlowStage.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkFlowStage.fulfilled, (state, action) => {
        state.loading = false;
        state.workFlowStagesList = action.payload;
        state.error = '';
      })
      .addCase(fetchWorkFlowStage.rejected, (state, action) => {
        state.loading = false;
        state.workFlowStagesList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default workFlowStagesSlice.reducer;
